import { commonenv } from 'common-env';

export const environment = {
  ...commonenv,
};
